import React, { useEffect, useState } from "react";
import profileImage from "../assets/8bd6079d223b8a9f5d7ebfde9aa987f9.jpg"; // update path if needed

export default function Description({ id }) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Trigger fade-in on mount
    setIsVisible(true);
  }, []);

  return (
    <section
      id={id}
      className={`relative max-w-6xl mx-auto px-6 sm:px-12 py-20 flex flex-col md:flex-row items-center gap-10 transition-opacity duration-1000 ${
        isVisible ? "opacity-100" : "opacity-0"
      }`}
    >
      {/* Left: Text */}
      <div className="flex-1 text-center md:text-left">
        <h1 className="text-black text-4xl sm:text-5xl font-serif font-normal mb-6 leading-snug">
          Hi there! I'm <span className="text-blue-600">Vatsal</span>
        </h1>
        <p className="text-gray-700 text-lg sm:text-xl leading-relaxed font-serif">
          - I am a Full Stack Developer specializing in AI automation and creating intelligent agents. I build innovative solutions that streamline processes, automate tasks, and enhance productivity. With expertise in both front-end and back-end development, I deliver robust, scalable applications while integrating AI technologies to solve real-world problems efficiently. I am passionate about leveraging automation and AI to transform ideas into impactful digital experiences.
        </p>
      </div>

      {/* Right: Image */}
      <div className="flex-1 flex justify-center md:justify-end mt-10 md:mt-0">
        <div className="relative w-72 h-80 sm:w-80 sm:h-96">
          {/* Decorative Arch Background */}
          <div className="absolute inset-0 bg-gradient-to-br from-orange-300 to-orange-400 rounded-t-[160px] rounded-b-[10px]"></div>

          {/* Image of Vatsal */}
          <img
            src={profileImage}
            alt="Vatsal Koriya"
            className="relative w-full h-full object-cover rounded-t-[160px] rounded-b-[10px]"
          />

          {/* Sparkle Decorations */}
          <div
            className="absolute top-1/4 -left-5 text-4xl text-yellow-300 transform -rotate-12"
            style={{ textShadow: "0 1px 3px rgba(0,0,0,0.2)" }}
          >
            &#10024;
          </div>
          <div
            className="absolute top-1/3 left-4 text-2xl text-yellow-300 transform rotate-12"
            style={{ textShadow: "0 1px 3px rgba(0,0,0,0.2)" }}
          >
            &#10022;
          </div>
        </div>
      </div>
    </section>
  );
}
